import { Row, Col } from 'react-bootstrap';
import { AccordionSection } from '@medifind/containers';
import { Skeleton } from '@medifind/shared-basic-components';
import classNames from 'classnames';
import styles from './ClinicalTrialShared.module.scss';

const ClinicalTrialTreatments = ({ treatments, isLoading }) => {
  return (
    <AccordionSection
      classes={{
        container: styles['accordian-container'],
        header: styles['accordian-header'],
        title: styles['accordian-title'],
        body: styles['accordian-body'],
      }}
      expandable
      title="Treatments"
      isLoading={isLoading}
    >
      {treatments &&
        treatments.map(({ description, groupType, title }, index) => {
          return (
            <Row key={`${index}-treatment`} className={styles['field-row']}>
              <Col>
                <div>
                  {groupType && <span className={classNames(styles['section-body-text'], styles['bold'])}>{groupType}: </span>}
                  {title}
                </div>
                <div>{description}</div>
              </Col>
            </Row>
          );
        })}
    </AccordionSection>
  );
};

export { ClinicalTrialTreatments as default, ClinicalTrialTreatments };
